import axios from 'axios'

const SchedulingService = {
  async get (params = {}) {
    return axios.get('lo/delivery-schedulings', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/delivery-scheduling-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('lo/exports/delivery-schedulings', { params })
  },

  async show (id) {
    return axios.get(`lo/delivery-schedulings/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/delivery-schedulings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/delivery-schedulings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/delivery-schedulings/${data.id}`, { data })
  }
}

export default SchedulingService
